import { useEffect, useState } from 'react';

/** Seconds left until `until` (an ISO date), ticking once a second; 0 when unset or past. */
export function useCountdown(until: string | null | undefined): number {
  const [now, setNow] = useState(() => Date.now());
  const target = until ? new Date(until).getTime() : 0;
  const secondsLeft = Math.max(0, Math.ceil((target - now) / 1000));

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [secondsLeft]);

  return secondsLeft;
}
